<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
        {title: this.$t(`menu.${serviceSlug}`), disabled: true},
        {title: this.$t('menu.iframe/logo-library'), active: true, meta: {type: 'string', value: `/${this.iframeService.slug}/${this.iframeService.slug}/logo-library`}},
        {title: logo.name, disabled: true}
      ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{$t('iframe.logos-library.update')}} </h5>


      <LogoDetail
        v-model="logoForm"
        :formErrors="logoErrors"
        :collapsable="true"
        :client-options="clientOptions"
      />

      <!-- Buttons row -->
      <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
        <va-button class="btn-cancel" @click="handleCancel">
          {{$t('iframe.actions.cancel')}}
        </va-button>

        <va-button @click="handleSave" :disabled="!canSubmit">
          {{$t('iframe.actions.save')}}
        </va-button>
      </div>
      <!-- --- --- --- -->


    </div>

  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import {IframeService} from "@/api/IframeService";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import MediaDetail from "@/components/iframe/media-library/MediaDetail";
import Errors from "@/utils/StandardErrors";
import LogoDetail from "@/components/iframe/logo-library/LogoDetail";
import Multiselect from "vue-multiselect";

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  components: {Multiselect, LogoDetail, LoadingPlaceholder, Breadcrumbs},
  data() {
    return {
      isLoading: true,
      logoForm: {
        client: null,
        logo: null,
        name: null,
      },
      logoErrors: new Errors(),
      logo: null,
    }
  },
  async mounted() {
    try {
      const resp = await IframeService.getLogoById(this.$route.params.id)
      this.logo = resp.data

      this.isLoading = false
      this.prefillForm()
    } catch (err) {
      //todo handle err
      console.log(err)
    }
  },
  methods: {
    prefillForm: function() {
      this.logoForm = this.logo
    },
    handleCancel: function() {
      this.$router.push({path:`/${this.iframeService.slug}/${this.iframeService.slug}/logo-library`})
    },
    handleSave: function() {
      this.isSubmiting = true
      let formDataToSubmit = {...this.logoForm}

      let formData = new FormData()

      delete(formDataToSubmit.client_id)
      Object.entries(formDataToSubmit).forEach(([key, val]) => {
        if(key === "client") {
          formData.append("clientId", val.id.toString())
        } else {
          formData.append(key, val)
        }
      })

      IframeService.updateLogo(this.logo.id, formData, (formData.icon !== null))
        .then(res => {
          this.showToast(this.$t('iframe.media_library.update_success'), this.$store.state.successToastOptions)
          this.handleCancel()
        })
        .catch(errors => {
          console.log(errors)
          if(errors.response.status === 422) {
            this.logoErrors.record(errors.response.data.errors, errorsPrefix)
          }
          this.showToast(this.$t('iframe.media_library.update_error'), this.$store.state.errorToastOptions)
        })
        .finally(() => { this.isSubmiting = false } )
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    entities: function () {
      return this.iframeService ? this.iframeService.entities : null
    },
    canSubmit() {
      return (this.logoForm.name !== null && this.logoForm.name !== '') && !this.isSubmiting && this.logoForm.logo !== null && this.logoForm.client !== null
    },
    clientOptions: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
